import Service from "../../service/index";


const Eventform = {
    namespaced: true,
    state: {
        createCase: [],
        casesAtSituation : [],
        casesAtHospital : [],
        newReferCase : [],
        searchText:null,
        startDate:null,
        endDate:null,

        form: {
            // FORM 1
            id: null,                       // Primary Key
            event_id: null,                 // เลขที่เหตุการ
            case_id: null,                  // เลขที่ศพ
            // images: [],                     //รูปสถานการณ์



            received_case_date: null,       // วัน รับแจ้ง *
            received_case_at: null,         // เวลา รับแจ้ง
            departed_date: null,            // วัน เริ่มเดินทาง *
            departed_at: null,              // เวลา เริ่มเดินทาง
            arrived_date: null,             // วัน ถึงสถานที่เกิดเหตุ *
            arrived_at: null,               // เวลา ถึงสถานที่เกิดเหตุ
            returned_date: null,            // วัน กลับจากที่เกิดเหตุ *
            returned_at: null,              // เวลา กลับจากที่เกิดเหตุ

            // ผู้สอบสวน
            response_officer_name: null,    // ชื่อพนักงานสอบสวนผู้แจ้ง
            police_station_id: null,        // สถานีตำรวจ
            doctor_name: null,              // แพทย์ชันสูตรร่วม
            circumstances_id: null,         // เหตุที่แจ้งเบื้องต้น

            // ผู้เสียชีวิต
            dead_name: null,                // ชื่อเต็ม
            dead_firstname: null,             // ชื่อจริง *
            dead_lastname: null,             // นามสกุล *
            birthDate: null,                // วันเ/ดือน/ปี เกิด
            dead_age: null,                 // อายุ
            dead_about_age: null,                 // อายุประมาณ
            dead_id: null,                  // เลขบัตรประขาขน
            dead_gender: null,              // เพศ

            dead_nationality: null,         // สัญชาติ

            dead_time: null,         // เวลาที่เสียชีวิต
            dead_date: null,         // วันที่เสียชีวิต
            day_before_identify: null,         // วันก่อนืทำการชันสูตร
            hours_before_identify: null,         // ชั่วโมงก่อนืทำการชันสูตร
            minutes_before_identify: null,         // นาทีก่อนืทำการชันสูตร


            // ที่อยู่ผู้เสียชีวิต<ตามบัตรประชาชน>
            dead_address_idCard:null,       // ที่อยู่
            dead_place_address_idCard: null,       // ที่อยู่(สถานที่)
            address_village_no_idCard: null,       // หมู้บ้าน
            address_street_idCard: null,           // ซอย
            address_road_idCard: null,             // ถนน
            address_province_id_idCard: null,      // จังหวัด
            address_district_id_idCard: null,      // อำเภอ
            address_sub_district_id_idCard: null,  // เขต



            // ที่อยู่ผู้เสียชีวิต<ปัจจุบัน>
            dead_place_address: null,       // ที่อยู่(สถานที่)
            address: null,                  // ที่อยู่
            address_village_no: null,       // หมู้บ้าน
            address_street: null,           // ซอย
            address_road: null,             // ถนน
            address_province_id: null,      // จังหวัด
            address_district_id: null,      // เขต/อำเภอ
            address_sub_district_id: null,  // แขวง/ตำบล



            // สถานที่ตาย
            dead_place_at: null,            // สถานที่ตาย
            location: null,                 // ชื่อ สถานที่ตาย
            village_no: null,               // หมู่
            lat: null,             // Latitude
            lon: null,             // Longitude
            location_province_id: null,     // จังหวัด
            location_district_id: null,     // เขต/อำเภอ
            location_sub_district_id: null, // แขวง/ตำบล
            location_style: null,           // ลักษณะของสถานที่ที่พบศพนั้นอยู่ (พิมพ์)

            short_history: null,            // ผู้เสียชีวิต ประวัติโดยสังเขป (พิมพ์)
            found_date: null,               // วันศพถูกพบ
            found_at: null,                 // เวลาที่สพถูกพบ
            found_name: null,               // ชื่อผู้แจ้งพบศพ

            treat_history: null,            // ผู้เสียชีวิต ประวัติการรักษา/โรคประจำตัว (พิมพ์)
            last_found_date: null,          // วัน ที่มีผู้พบว่ามีชีวิตอยู่เป็นครั้งสุดท้าย
            last_found_at: null,            // เวลา ที่มีผู้พบว่ามีชีวิตอยู่เป็นครั้งสุดท้าย

            death_reason_id1: null,          // สาเหตุการตาย1
            death_reason_id2: null,          // สาเหตุการตาย2
            death_reason_id3: null,          // สาเหตุการตาย3
            death_reason_id4: null,          // สาเหตุการตาย4
            ICD_No1: null,          // ICD1
            ICD_No2: null,          // ICD2
            ICD_No3: null,          // ICD3
            ICD_No4: null,          // ICD4
            death_reason_other: null,          // สาเหตุการตาย อื่นๆ (free text)

            death_reason_addition1: null,    // พฤติการณ์ที่ตาย1
            death_reason_addition2: null,    // พฤติการณ์ที่ตาย2
            death_reason_addition3: null,    // พฤติการณ์ที่ตาย3
            death_reason_addition4: null,    // พฤติการณ์ที่ตาย4
            death_reason_addition5: null,    // พฤติการณ์ที่ตาย5
            death_reason_addition_detail: null,   // รายละเอียดพฤติการณ์ที่ตาย


            // FORM 2
            // การแข็งตัวของศพ (Rigor Mortis)
            jaw : null,                     // กราม
            note_jaw : null,                // กราม > หมายเหตุ
            neck : null,                    // คอ
            note_neck : null,               // คอ > หมายเหตุ
            knuckle : null,                 // ข้อนิ้ว
            note_knuckle : null,            // ข้อนิ้ว > หมายเหตุ
            elbow : null,                   // ข้อศอก
            note_elbow : null,              // ข้อศอก > หมายเหตุ
            shoulder_joint : null,          // ข้อไหล่
            note_shoulder_joint : null,     // ข้อไหล่ > หมายเหตุ
            hip_joint : null,               // ข้อสะโพก
            note_hip_joint : null,          // ข้อสะโพก > หมายเหตุ
            knee_joint : null,              // ข้อเข่า
            note_knee_joint : null,         // ข้อเข่า > หมายเหตุ
            ankle : null,                   // ข้อเท้า
            note_ankle : null,              // ข้อเท้า > หมายเหตุ
            other : null,                   // อื่นๆ
            note_other : null,              // อื่นๆ > หมายเหตุ

            // การบาดเจ็บ และ/หรือพยาธิสภาพที่ตรวจพบ
            eye_injury_type_id:null,        // เยื่อบุตา
            eye_injury_type_other:null,     // เยื่อบุตา >
            eye_injury_note:"",             // ข้อไหล่ > หมายเหตุ
            neck_injury:null,                 // คอ
            neck_injury_note:"",            // ข้อไหล่ > หมายเหตุ
            arm_injury:null,                  // แขน
            arm_injury_note:"",             // แขน > หมายเหตุ
            leg_injury:null,                  // ขา
            leg_injury_note:"",             // ขา > หมายเหตุ



            is_body_injury_found:null,      // พยาธิสภาพอื่นๆ
            body_injury_found:null,         // พยาธิสภาพอื่นๆ > พบ (ระบุ)
            is_has_injury:null,             // บาดแผลที่ตรวจ
            item_found_amount : null,       // จำนวนการเก็บวัตถุพยานจากการชันสูตรพลิกศพ

            assumed_cause:null,             // ข้อสันนิษฐานการตายเบื้องต้น
            dead_management_id:null,        // ได้จัดการกับศพนั้นอย่างไร
            dead_management_other:null,     // ได้จัดการกับศพนั้นอย่างไร > อื่นๆ
            remark:null,                    // บันทึกอื่นๆ

            // ลงชื่อ
            officer_card_img:null,
            doctor_card_img:null,
            represent_card_img:null,
            attorney_card_img:null,
            admin_card_img:null,
            officer_name:null,
            officer_email:null,
            officer_position:null,
            sign_doctor_name:null,
            doctor_email:null,
            doctor_position:null,
            represent_name:null,
            represent_email:null,
            represent_position:null,
            attorney_name:null,
            attorney_email:null,
            attorney_position:null,
            admin_name:null,
            admin_email:null,
            admin_position:null,


            unknown_dead_name:null,
            unknown_dead_address:null,
            unknow_dead_address_id:null,
        },
        injuryForm: [],
        // สภาพหรือชิ้นส่วนของศพที่ปรากฏ
        // (appearances table)
        appearances: {
            shape_id: null,                 // รูปร่าง
            height: null,                   // ส่วนสูง (พิมพ์)
            skin_color_id: null,            // ผิวสี
            skin_color_other: null,         // ผิวสี อื่นๆ (พิมพ์)
            hair_style_id: null,            // เส้นผม
            hair_color: null,               // สีผม (พิมพ์)
            accessory:null,                 // เครื่องประดับ
            defect: null,                   // รอยสัก/ตำหนิ/แผลเป็น
            cloth:null,                     // เสื้อผ้าเครื่องแต่งกาย
        },
        // การเก็บวัตถุพยานจากการชันสูตรพลิกศพ
        // evidences table
        evidences: [],
        // การเปลี่ยนแปลงภายหลังการตาย
        transformations: {
            supravital_reaction_id: null,   // การกระตุ้นกล้ามเนื้อลาย (Supravital Reaction)
            temp: null,                     // อุณหภูมิของศพโดยการสัมผัส
            livor_mortis_id: null,          // การตกของเลือดสูเ่บื้องต่ำภายหลังตาย (Livor Mortis)
            livor_mortis_area: null,        // การตกของเลือดสูเ่บื้องต่ำภายหลังตาย > ตำแหน่งที่พบ
            blood_type_id: null,            // ลักษณะจางของสีเมื่อกด
            blood_color_id: null,           // สีที่ปรากฏ
            blood_color_other: null,        // สีที่ปรากฏ > อื่นๆ
            rot_type_id: null,              // ศพเน่า
            rot_type_other: null,           // ศพเน่า > อื่่นๆ
        },
        images_case:[],
        images_card:[],
        images_dead_body:[],
        injury:{
            name:'',
            type:'',
            typeName:'',
            index:'',
            x:'',
            y:'',
            image_Injury: null,

        },

    },
    mutations: {
        GET_CREATE_CASE: (state, data) => {
            console.log("GET_CREATE_CASE",data)
            state.createCase = data;
            state.form = data;
        },
        GET_CASE_SITUATION: (state, data) => {
            state.casesAtSituation = data;

        },
        GET_CASE_HOSPITAL: (state, data) => {
            state.casesAtHospital = data;

        },
        GET_NEW_REFER_CASE: (state, data) => {
            state.newReferCase = data;

        },
        GET_CASE_DATA: (state, data) => {
            if(data){
                state.form = data;
            }
        },
        GET_CARD_IMG_DATA: (state, data) => {
            if (data) {
                // state.form = data;
                switch (data.name) {
                    case  'officer_card_img': {
                        state.form.officer_card_img = data.image;
                        break;
                    }
                    case  'doctor_card_img': {
                        state.form.doctor_card_img = data.image;
                        break;
                    }

                    case  'represent_card_img': {
                        state.form.represent_card_img = data.image;
                        break;
                    }

                    case  'attorney_card_img': {
                        state.form.attorney_card_img = data.image;
                        break;
                    }

                    case  'admin_card_img': {
                        state.form.admin_card_img = data.image;
                        break;
                    }
                }
            }
        },
        GET_CASE_DATA_AFTER_UPDATE: (state, data) => {
            if(data){
                state.form = data;
            }
        },
        GET_CASE_INJURY_DATA: (state, data) => {
            if(data){
                console.log("datadata",data)
                state.injuryForm = JSON.parse(data);
            }
        },
        SET_APPEARANCE: (state, data) => {
            state.appearances = data;

        },
        SET_EVIDENCE: (state, data) => {
            state.evidences = data;
        },
        SET_TRANSFORMATION: (state, data) => {
            state.transformations = data;
            if(data.rigor_mortis){
                let obj = JSON.parse(data.rigor_mortis)
                if(obj){
                    for (let key in obj){
                        state.form[key] = obj[key]
                    }
                }
            }

        },
        GET_CASE_IMAGE:(state,res) =>{
            console.log('image case res',res)
            state.images_case = res;
        },
        GET_CARD_IMAGE:(state,res) =>{
            console.log('image card res',res)
            if (res.type =='card'){
                state.form[`${res.mode}`] = res.image;
            }else {
                state.images_card = res;
            }
        },GET_DEAD_BODY_IMAGE:(state,res) =>{
            console.log('deadBody res',res)
            state.images_dead_body = res;
        },
        // DELETE_CASE_IMAGE:(state,res) =>{
        //     state.images_case = res;
        // },
        // DELETE_CARD_IMAGE:(state,res) =>{
        //     state.images_card = res;
        // },
        SET_FORM_EVENT:(state,res)=>{
            state.form = res;
        },
        SET_INJURY_FORM_EVENT:(state,res)=>{
            state.injuryForm = res;
            console.log('state.injuryForm', state.injuryForm)
        },
        GET_TRANSFORM_DATA: (state, data) => {
            state.Transfotmation = data;
        },
        // GET_EXPORT:(state,data)=>{
        //     state.dataExportCases =data;
        // },
        CLEAR_FORM_DATA: state => {
            state.form = {
                // FORM 1
                id: null,                       // Primary Key
                event_id: null,                 // เลขที่เหตุการ
                case_id: null,                  // เลขที่ศพ

                received_case_date: null,       // วัน รับแจ้ง *
                received_case_at: null,         // เวลา รับแจ้ง
                departed_date: null,         // วัน รับแจ้ง *
                departed_at: null,              // เวลา เริ่มเดินทาง
                arrived_date: null,             // วัน ถึงสถานที่เกิดเหตุ *
                arrived_at: null,               // เวลา ถึงสถานที่เกิดเหตุ
                returned_date: null,            // วัน กลับจากที่เกิดเหตุ *
                returned_at: null,              // เวลา กลับจากที่เกิดเหตุ

                // ผู้สอบสวน
                response_officer_name: null,    // ชื่อพนักงานสอบสวนผู้แจ้ง
                police_station_id: null,        // สถานีตำรวจ
                doctor_name: null,              // แพทย์ชันสูตรร่วม
                circumstances_id: null,         // เหตุที่แจ้งเบื้องต้น

                // ผู้เสียชีวิต
                dead_name: null,                // ชื่อจริง
                dead_firstname: null,             // ชื่อจริง *
                dead_lastname: null,             // นามสกุล *
                birthDate: null,                // วัน/เดือน/ปี เกิด
                dead_age: null,                 // อายุ
                dead_about_age: null,                 // อายุประมาณ
                dead_id: null,                  // เลขบัตรประขาขน
                dead_gender: null,              // เพศ

                dead_nationality: null,         // สัญชาติ

                dead_time: null,         // เวลาที่เสียชีวิต
                dead_date: null,         // วันที่เสียชีวิต
                day_before_identify: null,         // วันก่อนืทำการชันสูตร
                hours_before_identify: null,         // ชั่วโมงก่อนืทำการชันสูตร
                minutes_before_identify: null,         // นาทีก่อนืทำการชันสูตร

                // ที่อยู่ผู้เสียชีวิต<ตามบัตรประชาชน>
                dead_address_idCard:null,       // ที่อยู่
                dead_place_address_idCard: null,       // ที่อยู่(สถานที่)
                address_village_no_idCard: null,       // หมู้บ้าน
                address_street_idCard: null,           // ซอย
                address_road_idCard: null,             // ถนน
                address_province_id_idCard: null,      // จังหวัด
                address_district_id_idCard: null,      // อำเภอ
                address_sub_district_id_idCard: null,  // เขต



                // ที่อยู่ผู้เสียชีวิต<ปัจจุบัน>
                dead_place_address: null,       // ที่อยู่(สถานที่)
                address: null,                  // ที่อยู่
                address_village_no: null,       // หมู้บ้าน
                address_street: null,           // ซอย
                address_road: null,             // ถนน
                address_province_id: null,      // จังหวัด
                address_district_id: null,      // อำเภอ
                address_sub_district_id: null,  // เขต



                // สถานที่ตาย
                dead_place_at: null,            // สถานที่ตาย
                location: null,                 // ชื่อ สถานที่ตาย
                village_no: null,               // หมู่
                location_lat: null,             // Latitude
                location_lng: null,             // Longitude
                location_province_id: null,     // จังหวัด
                location_district_id: null,     // อำเภอ
                location_sub_district_id: null, // เขต
                location_style: null,           // ลักษณะของสถานที่ที่พบศพนั้นอยู่ (พิมพ์)

                short_history: null,            // ผู้เสียชีวิต ประวัติโดยสังเขป (พิมพ์)
                found_date: null,               // วันศพถูกพบ
                found_at: null,                 // เวลาที่สพถูกพบ
                found_name: null,               // ชื่อผู้แจ้งพบศพ

                treat_history: null,            // ผู้เสียชีวิต ประวัติการรักษา/โรคประจำตัว (พิมพ์)
                last_found_date: null,          // วัน ที่มีผู้พบว่ามีชีวิตอยู่เป็นครั้งสุดท้าย
                last_found_at: null,            // เวลา ที่มีผู้พบว่ามีชีวิตอยู่เป็นครั้งสุดท้าย

                death_reason_id1: null,          // สาเหตุการตาย1
                death_reason_id2: null,          // สาเหตุการตาย2
                death_reason_id3: null,          // สาเหตุการตาย3
                death_reason_id4: null,          // สาเหตุการตาย4
                ICD_No1: null,          // ICD1
                ICD_No2: null,          // ICD2
                ICD_No3: null,          // ICD3
                ICD_No4: null,          // ICD4
                death_reason_other: null,          // สาเหตุการตาย อื่นๆ (free text)
                death_reason_addition1: null,    // พฤติการณ์ที่ตาย1
                death_reason_addition2: null,    // พฤติการณ์ที่ตาย2
                death_reason_addition3: null,    // พฤติการณ์ที่ตาย3
                death_reason_addition4: null,    // พฤติการณ์ที่ตาย4
                death_reason_addition5: null,    // พฤติการณ์ที่ตาย5
                death_reason_addition_detail: null,   // รายละเอียดพฤติการณ์ที่ตาย


                // FORM 2
                // การเปลี่ยนแปลงภายหลังการตาย
                supravital_reaction_id: null,   // การกระตุ้นกล้ามเนื้อลาย (Supravital Reaction)
                temp: null,                     // อุณหภูมิของศพโดยการสัมผัส
                // การแข็งตัวของศพ (Rigor Mortis)
                jaw : null,                     // กราม
                note_jaw : null,                // กราม > หมายเหตุ
                neck : null,                    // คอ
                note_neck : null,               // คอ > หมายเหตุ
                knuckle : null,                 // ข้อนิ้ว
                note_knuckle : null,            // ข้อนิ้ว > หมายเหตุ
                elbow : null,                   // ข้อศอก
                note_elbow : null,              // ข้อศอก > หมายเหตุ
                shoulder_joint : null,          // ข้อไหล่
                note_shoulder_joint : null,     // ข้อไหล่ > หมายเหตุ
                hip_joint : null,               // ข้อสะโพก
                note_hip_joint : null,          // ข้อสะโพก > หมายเหตุ
                knee_joint : null,              // ข้อเข่า
                note_knee_joint : null,         // ข้อเข่า > หมายเหตุ
                ankle : null,                   // ข้อเท้า
                note_ankle : null,              // ข้อเท้า > หมายเหตุ
                other : null,                   // อื่นๆ
                note_other : null,              // อื่นๆ > หมายเหตุ

                // การบาดเจ็บ และ/หรือพยาธิสภาพที่ตรวจพบ
                eye_injury_type_id:null,        // เยื่อบุตา
                eye_injury_type_other:null,     // เยื่อบุตา >
                eye_injury_note:"",             // ข้อไหล่ > หมายเหตุ
                neck_injury:null,                 // คอ
                neck_injury_note:"",            // ข้อไหล่ > หมายเหตุ
                arm_injury:null,                  // แขน
                arm_injury_note:"",             // แขน > หมายเหตุ
                leg_injury:null,                  // ขา
                leg_injury_note:"",             // ขา > หมายเหตุ


                is_body_injury_found:null,      // พยาธิสภาพอื่นๆ
                body_injury_found:null,         // พยาธิสภาพอื่นๆ > พบ (ระบุ)
                is_has_injury:null,             // บาดแผลที่ตรวจ
                item_found_amount : null,       // จำนวนการเก็บวัตถุพยานจากการชันสูตรพลิกศพ

                assumed_cause:null,             // ข้อสันนิษฐานการตายเบื้องต้น
                dead_management_id:null,        // ได้จัดการกับศพนั้นอย่างไร
                dead_management_other:null,     // ได้จัดการกับศพนั้นอย่างไร > อื่นๆ
                remark:null,                    // บันทึกอื่นๆ

                // ลงชื่อ
                officer_sign_img:null,
                officer_name:null,
                officer_email:null,
                officer_position:null,
                doctor_sign_img:null,
                officer_card_img:null,
                doctor_card_img:null,
                represent_card_img:null,
                attorney_card_img:null,
                admin_card_img:null,
                sign_doctor_name:null,
                doctor_email:null,
                doctor_position:null,
                represent_sign_img:null,
                represent_name:null,
                represent_email:null,
                represent_position:null,
                attorney_sign_img:null,
                attorney_name:null,
                attorney_email:null,
                attorney_position:null,
                admin_sign_img:null,
                admin_name:null,
                admin_email:null,
                admin_position:null,
            },

                state.evidences = [],
                state.newReferCase = [],
                state.injuryForm = [],
                state.appearances =  {
                    shape_id: null,                 // รูปร่าง
                    height: null,                   // ส่วนสูง (พิมพ์)
                    skin_color_id: null,            // ผิวสี
                    skin_color_other: null,         // ผิวสี อื่นๆ (พิมพ์)
                    hair_style_id: null,            // เส้นผม
                    hair_color: null,               // สีผม (พิมพ์)
                    accessory:null,                 // เครื่องประดับ
                    defect: null,                   // รอยสัก/ตำหนิ/แผลเป็น
                    cloth:null,                     // เสื้อผ้าเครื่องแต่งกาย
                },
                state.transformations =  {
                    supravital_reaction_id: null,   // การกระตุ้นกล้ามเนื้อลาย (Supravital Reaction)
                    temp: null,                     // อุณหภูมิของศพโดยการสัมผัส
                    livor_mortis_id: null,          // การตกของเลือดสูเ่บื้องต่ำภายหลังตาย (Livor Mortis)
                    livor_mortis_area: null,        // การตกของเลือดสูเ่บื้องต่ำภายหลังตาย > ตำแหน่งที่พบ
                    blood_type_id: null,            // ลักษณะจางของสีเมื่อกด
                    blood_color_id: null,           // สีที่ปรากฏ
                    blood_color_other: null,        // สีที่ปรากฏ > อื่นๆ
                    rot_type_id: null,              // ศพเน่า
                    rot_type_other: null,           // ศพเน่า > อื่่นๆ
                }

        },
    },
    actions: {
        setCaseID({commit}, id){
            return Service.Eventform.createCaseid(id)
                .then(data=>{
                    commit("GET_CREATE_CASE",data)
                })
        },
        onGetAppearancesID({commit},data){
            return Service.Eventform.getAppearances(data.id)
                .then(res=>{
                    console.log('set appearance', res)
                    commit("SET_APPEARANCE",res)
                })
        },
        onGetTransformationID({commit},data){
            return Service.Eventform.getTransformationID(data.id)
                .then(res=>{
                    console.log('onGetTransformationID', res)
                    commit("SET_TRANSFORMATION",res);
                })
        },
        onGetEvidence({commit},data){
            return Service.Eventform.getEvidence(data.id)
                .then(res=>{
                    commit("SET_EVIDENCE",res);
                    return res;
                })
        },
        onDeleteEvidence({commit},data){
            return Service.Eventform.deleteEvidence(data)
                .then(res=>{
                    commit("SET_EVIDENCE",res);
                })
        },
        onGetCaseSituation({commit}){
            return Service.Eventform.getCase(1)
                .then(data=>{
                    commit("GET_CASE_SITUATION",data)
                })
        },
        onGetCaseHospital({commit}){
            return Service.Eventform.getCase(2)
                .then(data=>{
                    commit("GET_CASE_HOSPITAL",data)
                })
        },
        onGetNewReferCase({commit}, id){
            return Service.Eventform.getNewReferCase(id)
                .then(data=>{
                    // commit("GET_NEW_REFER_CASE",data)
                    return data
                })
        },
        onGetCaseID({commit},data){
            let isReceived = data.isReceived
            let isRefer =   data.isRefer
            console.log('onGetCaseID',isReceived,isRefer)
            return Service.Eventform.getCaseID(data.id, isReceived,isRefer)
                .then(res=>{
                    console.log('getCaseID',res)
                    commit("GET_CASE_DATA",res)
                })
        },
        onGetSearch({commit},data){
            let dataSearch ={
                startDate:data.startDate,
                endDate:data.endDate,
                searchText:data.searchText,
                type:data.type,

            }
            if (data.type == 1){
                return Service.Eventform.getSearch(dataSearch)
                    .then(res=>{
                        commit("GET_CASE_SITUATION",res)
                    })
            }else if (data.type == 2){
                return Service.Eventform.getSearch(dataSearch)
                    .then(res=>{
                        commit("GET_CASE_HOSPITAL",res)
                    })
            }
        },
        onGetExport({commit},data){
            return Service.Eventform.getExport(data)
        },
        onGetExportSubmission({commit},data){
            return Service.Eventform.getExportSubmission(data)
        },
        onGetExportRequisition({commit},data){
            return Service.Eventform.getExportRequisition(data)
        },
        onGetExportRefer({commit},data){
            return Service.Eventform.getExportRefer(data)
        },
        putCaseData({commit},data){
            let key = Object.keys(data)[1];
            let val = data[key];
            let obj = {};
            obj[key] = val

            console.log('putCaseData',data.id,obj)
            return Service.Eventform.putCaseform(data.id,obj).then(res => {
                // commit("GET_CASE_DATA_AFTER_UPDATE",res)
                // console.log('update ss',res)
                return res;

            })
        },
        postInjuryData({commit},data){
            let case_id = data.id;
            let case_injury_data = data.data;
            let obj = {};
            obj['data'] = case_injury_data

            console.log('postInjuryData',case_id,case_injury_data)
            return Service.Eventform.postInjuryCaseForm(case_id,obj).then(res => {
                commit("SET_INJURY_FORM_EVENT",res);
                return res;
            })
        },
        getInjuryData({commit},data){
            console.log("getInjuryData",data)
            return Service.Eventform.getInjuryCaseForm(data).then(res => {
                console.log("Res getInjuryData",res)
                commit("SET_INJURY_FORM_EVENT",res);
                return res;
            })
        },

        putAppearancesData({commit},data){
            let key = Object.keys(data)[1];
            let val = data[key];
            let obj = {};
            obj[key] = val

            console.log('putAppearancesData',data.id,obj)
            return Service.Eventform.putAppearances(data.id,obj).then(res => {
                // commit("SET_APPEARANCE",res);
            })
        },
        putTransformationData({commit},data){
            let key = Object.keys(data)[1];
            let val = data[key];
            let obj = {};
            obj[key] = val

            console.log('putTransformationData',data.id,obj)

            return Service.Eventform.putTransformation(data.id,obj).then(res => {
                return res;
                // commit("SET_TRANSFORMATION",res);
            })
        },
        addEvidence({commit},data){
            let myJSONdata = JSON.stringify(data.items)
            console.log('addEvidence',data.id,myJSONdata)
            return Service.Eventform.addEvidence(data.id,data.items).then(res => {
                commit("SET_EVIDENCE",res);
            })
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        refer({commit}, data){
            let myJSONdata = JSON.stringify(data)
            console.log('refer', myJSONdata)
            return Service.Eventform.refer(data.id, data.item);
        },
        saveImage({commit}, data){
            console.log("saveImage")
            return Service.Eventform.saveImage(data.id, data.item).then(res => {

                commit("SET_FORM_EVENT",res);
            })
        },
        onUploadImg({commit},data){
            console.log("onUploadImg")
            return Service.Eventform.uploadImg(data).then(res =>{
                if (data.mode == 'case'){
                    console.log("onUploadImg",res)
                    commit("GET_CASE_IMAGE",res)
                }else if (data.mode == 'card'){
                    console.log("onUploadImg",res)
                    commit("GET_CARD_IMAGE",res)
                }else if (data.mode == 'deadBody'){
                    console.log("onUploadImg",res)
                    commit("GET_DEAD_BODY_IMAGE",res)
                }
            })
        },
        onGetCaseImg({commit},data){
            return Service.Eventform.getCaseImg(data)
                .then(res=>{
                    console.log("onGetCaseImg",res)
                    commit("GET_CASE_IMAGE",res)
                })
        },
        onGetCardImg({commit},data){
            return Service.Eventform.getCardImg(data)
                .then(res=>{
                    console.log("onGetCardImg",res)
                    commit("GET_CARD_IMAGE",res)
                })
        },
        onGetDeadBodyImg({commit},data){
            return Service.Eventform.getDeadBodyImg(data)
                .then(res=>{
                    console.log("onDeadBodyImg",res)
                    commit("GET_DEAD_BODY_IMAGE",res)
                })
        },
        onDeleteCaseImg({commit},data){
            console.log("onDeleteCaseImg")
            return Service.Eventform.deleteCaseImg(data)
                .then(res=>{
                    console.log("onDeleteCaseImg",res)
                    commit("GET_CASE_IMAGE",res)
                })

        },
        onDeleteCardImg({commit},data){
            console.log("onDeleteCardImg")
            return Service.Eventform.deleteCardImg(data)
                .then(res=>{
                    console.log("onDeleteCardImg",res)
                    commit("GET_CARD_IMAGE",res)
                    return res
                })

        },
        onDeleteDeadBodyImg({commit},data){
            console.log("onDeleteDeadBodyImg")
            return Service.Eventform.deleteDeadBodyImg(data)
                .then(res=>{
                    console.log("onDeleteDeadBodyImg",res)
                    commit("GET_DEAD_BODY_IMAGE",res)
                })

        },
        onUploadCardImg({commit},data){
            console.log("onUploadCardImg",data.name)
            return Service.Eventform.uploadCardImg(data)
                .then(res=>{
                    console.log("onUploadCardImg",res)
                    commit("GET_CARD_IMG_DATA",res)
                    return res;
                })

        },
        onGetImgCard({commit},data){
            console.log("onGetCardImg",data.name)
            return Service.Eventform.getImgCard(data)
                .then(res=>{
                    console.log("onGetCardImg",res)
                    commit("GET_CARD_IMG_DATA",res)
                    return res;
                })

        },
        onSendEmail({commit},data){
            return Service.Eventform.sendEmail(data)
                .then(res=>{
                    console.log("onSendEmail",res)
                    return res;
                })

        },
        onChangeStatus({commit},data){
            return Service.Eventform.changeStatus(data)
                .then(res=>{
                    console.log("changeStatus",res)
                    return res;
                })

        },
        onSaveLog({commit},data){
            return Service.Eventform.saveLog(data)
                .then(res=>{
                    console.log("changeStatus",res)
                    return res;
                })

        },

    }
};
export default Eventform;
